export default {"src":"/_next/static/media/close-blue.d550965b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};